import React, { useEffect } from 'react';
import AboutImage from '../assets/images/logo.png';
import logo from "../../assets/images/senoffre.png";

import RecentOffers from './RecentOffers';
import CategorySearch from './CategorySearch';
import FeaturedCompanies from './FeaturedCompanies';
import RegionSelector from './RegionSelector';
import StatsOverview from './StatsOverview';
import PremiumCompaniesGrid from './PremiumCompaniesGrid';
import ModernFluidCarousel from './ModernFluidCarousel';
import '../assets/css/custom-landing.css';

// Using ModernFluidCarousel for ads display

const Company = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.reveal');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.15 }
        );
        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);
    return (
        <>
                    <div className="row align-items-center">
                <div className="col-lg-12 m-b30">
                    <div className="dz-contant style-1">
                        <div className="section-head">
                            <h2 className="title wow fadeInUp title-premium">Espace Premium</h2>
                            <span className="title-premium-badge">Premium</span>
                        </div>
                        <div className="wow fadeInUp">
                            <PremiumCompaniesGrid />
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Espace Publicités */}
            <div className="row align-items-center m-t50">
                <div className="col-lg-12 m-b30">
                    <div className="dz-contant style-1">
                        <div className="section-head" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <h2 className="title wow fadeInUp" style={{ color: '#1e7e34', margin: 0 }}>Espace Publicités</h2>
                            <span className="title-premium-badge" style={{ background: 'linear-gradient(135deg, #1e7e34, #28a745)' }}>Ads</span>
                        </div>
                        <div className="wow fadeInUp">
                            <ModernFluidCarousel />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row align-items-center">
                <div className="col-lg-12 m-b30">
                    <div className="dz-contant style-1">
                        <div className="section-head">
                            <h2 className="title wow fadeInUp title-premium">Qui sommes nous</h2>
                        </div>
                        <p className="wow fadeInUp">
                        Senoffre est une plateforme qui informe sur l'actualité des marchés publics et privés du Sénégal.
Elle est spécialisée dans la publication des appels d’offres, des avis à manifestation d'intéret et des demandes de prix à compétion ouverte. Quel que soit votre secteur d'activité (études, travaux, fournitures ou services), Senoffre vous permet d'accéder à l'ensemble des appels d'offres publiés dans toutes les régions du Sénégal.
Plusieurs formules vous sont proposées, allant de l'accès libre (gratuit) à l'abonnement annuel, pour vous accompagner dans l'identification de nouvelles opportunités d'affaires. L'abonnement vous permettra ainsi de recevoir quotidiennement par sms et mail des offres sélectionnées sur mesure. 
                        </p>
                    </div>
                </div>
            </div>
            {/* Offres récentes placées entre l'intro et la recherche par catégorie */}
            <RecentOffers />
            <CategorySearch />
            <FeaturedCompanies />
            {/* <RegionSelector /> */}
            <StatsOverview />
        </>
    );
};

export default Company;